import { useEffect } from 'react';
import {
    List,
    ListItemButton,
    ListItemText,
    useAppDispatch,
    useAppSelector,
} from '../../../base';
import { toolsSelectors, toolsActions, userSelectors } from '../../../actions';
import { IClientChat } from '../../../common';
import UserPreview from '../UserPreview';
import {
    MenuWrapper,
    AddJobButtonStyled,
    LinksListScrollableContainer,
    ListItemStyled,
    UserPreviewWrapper,
} from './LeftSidemenu.styles';
import { RoutePaths } from '../../../routes/RoutePaths';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LeftSidemenuComponent = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const chatsList = useAppSelector(toolsSelectors.getChatsList);
    const userData = useAppSelector(userSelectors.getMyUser);
    const activeChatId = useAppSelector(toolsSelectors.getActiveChatId);

    useEffect(() => {
        if (userData?.toolsCompanyProfiles[0]?.value) {
            dispatch(
                toolsActions.fetchChatsList({
                    companyId: userData?.toolsCompanyProfiles[0].value,
                })
            );
        }
    }, [dispatch, userData]);

    const handleChatClick = (uuid: string) => {
        if (location.pathname !== RoutePaths.chat) {
            const navPath = RoutePaths.chat;
            navigate(navPath);
        }
        if (activeChatId !== uuid) {
            dispatch(
                toolsActions.setActiveChatHistory({
                    chatHistory: [],
                    generatedContent: [],
                })
            );
            dispatch(toolsActions.setActiveChatId(uuid.toString()));
        }
    };

    const handleAddJobClick = () => {
        if (location.pathname !== RoutePaths.chat) {
            const navPath = RoutePaths.chat;

            navigate(navPath);
        }
        dispatch(toolsActions.setActiveChatId(null));
        dispatch(
            toolsActions.setActiveChatHistory({
                chatHistory: [],
                generatedContent: [],
            })
        );
    };

    return (
        <MenuWrapper>
            <AddJobButtonStyled
                variant="contained"
                color="secondary"
                fullWidth
                onClick={handleAddJobClick}
            >
                {t('tools.leftSideMenu.createNewJob')}
            </AddJobButtonStyled>
            <LinksListScrollableContainer>
                <List disablePadding>
                    {chatsList.map((link: IClientChat) => (
                        <ListItemStyled key={link.uuid} disablePadding>
                            <ListItemButton
                                onClick={() => handleChatClick(link.uuid)}
                            >
                                <ListItemText
                                    primary={link.title}
                                    primaryTypographyProps={{
                                        variant: 'subtitle2',
                                        color: 'text.secondary',
                                    }}
                                />
                            </ListItemButton>
                        </ListItemStyled>
                    ))}
                </List>
            </LinksListScrollableContainer>
            <UserPreviewWrapper>
                <UserPreview />
            </UserPreviewWrapper>
        </MenuWrapper>
    );
};

export default LeftSidemenuComponent;
